// extracted by mini-css-extract-plugin
export default {"galleryWidth":"Gallery_galleryWidth__KAuAX"};